import { useEffect } from 'react';

import { UserReferrer } from 'models';

import { useLocalEvent } from 'hooks/use-local-event';
import { useLocalUserInfo } from 'hooks/use-local-user-info';
import { showtimeState } from 'state/showtime';

const useSetShowShowtime = () => {
    const { localEvent } = useLocalEvent();
    const { referrer } = useLocalUserInfo();

    useEffect(() => {
        const isREPlus = referrer === UserReferrer.REPLUS;

        if (isREPlus) {
            showtimeState.showShowtime = true;
        } else {
            showtimeState.showShowtime = false;
        }

        if (localEvent && isREPlus) {
            const now = Date.now();
            const start = new Date(localEvent.start).getTime();
            const end = new Date(localEvent.end).getTime();
            const timePadding = 2 * 24 * 60 * 60 * 1000; // 2 days

            // active 2 days before and 2 days after the event
            const isActive = start - timePadding <= now && end + timePadding >= now;

            showtimeState.showShowtimeAndActiveEvent = isActive;
        } else {
            showtimeState.showShowtimeAndActiveEvent = false;
        }
    }, [localEvent, referrer]);
};

export { useSetShowShowtime };
